export default {
  name: 'test-center'
};
